// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-toolbar {
  border-bottom: 1px solid #ccc !important;
}

.badgeposition {
  position: absolute;
  left: 70px;
  top: 5px;
}

.tripsBadgeposition {
  position: absolute;
  left: 37px;
  top: 5px;
  margin-right: 4px;
}

.custom-sidemenu {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

/* Default styles for vendor and operator (userType 2 & 3) */
.my-custom-menu:not(.dark-theme) {
  --side-width: 25%;
}

/* Styles for charter (userType 7) */
.dark-theme.my-custom-menu {
  --side-width: 280px;
}

/* Responsive adjustments for charter */
@media (min-width: 768px) {
  .dark-theme.my-custom-menu {
    --side-width: 280px;
  }
}
/* Vendor/Operator specific styles */
.my-custom-menu:not(.dark-theme) ion-list ion-item {
  padding: 0px 0px 0px 0px;
  height: 44px !important;
}

.my-custom-menu:not(.dark-theme) ion-list {
  background: none !important;
  --background: #fafaff !important;
}

.my-custom-menu:not(.dark-theme) ion-note {
  margin-bottom: 30px;
}

.my-custom-menu:not(.dark-theme) ion-list-header,
.my-custom-menu:not(.dark-theme) ion-note {
  padding-left: 10px;
}

.my-custom-menu:not(.dark-theme) ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

.my-custom-menu:not(.dark-theme) ion-list#inbox-list ion-list-header {
  font-size: 16px;
  min-height: 20px;
}

.my-custom-menu:not(.dark-theme) ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

.my-custom-menu:not(.dark-theme) ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

.my-custom-menu:not(.dark-theme) ion-item.selected {
  --background: var(--ion-highlight-background-color-sidemenu) !important;
}

.my-custom-menu:not(.dark-theme) ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

.my-custom-menu:not(.dark-theme) ion-item ion-icon {
  color: #616e7e;
}

.my-custom-menu:not(.dark-theme) ion-item.selected ion-label {
  color: var(--ion-color-primary) !important;
}
.my-custom-menu:not(.dark-theme) ion-item.selected span {
  color: var(--ion-color-primary) !important;
}

/* Charter specific styles (dark theme) */
.dark-theme ion-content {
  --background: #121212 !important;
  --color: white !important;
}

.dark-content {
  background: #121212 !important;
}

.dark-toolbar {
  --background: #1e1e1e !important;
  --color: white !important;
  border-bottom: 1px solid #333 !important;
  padding-block: 15px;
}

.dark-list {
  background: #121212 !important;
}

.dark-item {
  --background: #121212 !important;
  --color: white !important;
  --border-color: #333 !important;
}

.dark-item.selected {
  --background: #333 !important;
}

.dark-item ion-icon {
  color: white !important;
}

.dark-footer {
  background: #1e1e1e !important;
}

.dark-footer ion-item {
  --background: #1e1e1e !important;
  --color: white !important;
}

/* Profile Header (charter only) */
.profile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  width: 100%;
  background-color: #1e1e1e;
}

.profile-image-container {
  margin-inline: 15px;
}

.profile-image {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.profile-info {
  flex: 1;
}

.profile-name {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.profile-email {
  margin: 0;
  font-size: 12px;
  color: #aaa;
}

/* Default Header Styles */
.defaultHeader .gravatar img {
  border: 2px solid #444;
  border-radius: 50%;
}

.custom-header-design label {
  font-size: 16px;
  display: block;
  text-align: center;
  margin-top: 8px;
}

/* Common utility classes */
.select-radio-icon {
  font-size: 2.4rem;
  padding-right: 8px;
}

.login-submit-button-design {
  width: 100%;
  margin-top: 5px !important;
  margin-left: 0px !important;
  text-transform: none !important;
}

.app-version {
  float: right;
  font-size: 10px;
  padding-top: 3px;
  color: #acaaaa;
}

.wallet-fotter {
  padding-left: 0px;
  bottom: 4px;
  padding: 5px !important;
}

.md .custom-heder-toolbar {
  height: 171px !important;
  min-height: 189px !important;
  display: block !important;
}

.ios .custom-heder-toolbar {
  height: 171px !important;
  min-height: 210px !important;
  display: block !important;
}

@media (min-width: 768px) {
  .hide-all-lg {
    display: none;
  }
}
.wallet-footer {
  margin-left: 80px;
  line-height: 0.2;
  margin-top: 11px;
}
@media (min-width: 768px) {
  .wallet-footer {
    margin-left: 140px;
  }
}

.left-padding {
  padding: 16px 16px 16px 0;
}

.padding {
  padding: 10px;
}

ion-menu ion-content ion-list .item .sc-ion-label-md-h {
  color: var(--ion-color-headertext) !important;
}

/* Vendor/Operator selected item style */
.my-custom-menu:not(.dark-theme) ion-item.selected {
  --background: var(--ion-highlight-background-color-sidemenu) !important;
}

.my-custom-menu:not(.dark-theme) ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

/* Charter selected item style */
.dark-item.selected {
  --background: #333 !important;
}

.ios .dark-toolbar {
  padding-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AACA;EACE,2EAAA;AAAF;;AAGA;EACE,wCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAAF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;;AAGA,4DAAA;AACA;EACE,iBAAA;AAAF;;AAGA,oCAAA;AACA;EACE,mBAAA;AAAF;;AAGA,uCAAA;AACA;EACE;IACE,mBAAA;EAAF;AACF;AAGA,oCAAA;AACA;EACE,wBAAA;EACA,uBAAA;AADF;;AAIA;EACE,2BAAA;EACA,gCAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;;EAEE,kBAAA;AADF;;AAIA;EACE,2DAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADF;;AAIA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AADF;;AAIA;EACE,uEAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAKE;EACE,0CAAA;AAFJ;AAIE;EACE,0CAAA;AAFJ;;AAMA,yCAAA;AACA;EACE,gCAAA;EACA,yBAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,gCAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,gCAAA;EACA,yBAAA;EACA,+BAAA;AAHF;;AAMA;EACE,6BAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,gCAAA;EACA,yBAAA;AAHF;;AAMA,kCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wCAAA;AAHF;;AAMA;EACE,OAAA;AAHF;;AAMA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAHF;;AAMA;EACE,SAAA;EACA,eAAA;EACA,WAAA;AAHF;;AAMA,0BAAA;AACA;EACE,sBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAHF;;AAMA,2BAAA;AACA;EACE,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;AAHF;;AAMA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAAA;EACA,uBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,4BAAA;EACA,yBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,4BAAA;EACA,yBAAA;AAHF;;AAMA;EACE;IACE,aAAA;EAHF;AACF;AAMA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AAJF;AAME;EALF;IAMI,kBAAA;EAHF;AACF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,6CAAA;AAHF;;AAMA,wCAAA;AACA;EACE,uEAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA,gCAAA;AACA;EACE,6BAAA;AAHF;;AAMA;EACE,iBAAA;AAHF","sourcesContent":["\nion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-toolbar {\n  border-bottom: 1px solid #ccc !important;\n}\n\n.badgeposition {\n  position: absolute;\n  left: 70px;\n  top: 5px;\n}\n\n.tripsBadgeposition {\n  position: absolute;\n  left: 37px;\n  top: 5px;\n  margin-right: 4px;\n}\n\n.custom-sidemenu {\n  --padding-start: 8px;\n  --padding-end: 8px;\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\n/* Default styles for vendor and operator (userType 2 & 3) */\n.my-custom-menu:not(.dark-theme) {\n  --side-width: 25%;\n}\n\n/* Styles for charter (userType 7) */\n.dark-theme.my-custom-menu {\n  --side-width: 280px;\n}\n\n/* Responsive adjustments for charter */\n@media (min-width: 768px) {\n  .dark-theme.my-custom-menu {\n    --side-width: 280px;\n  }\n}\n\n/* Vendor/Operator specific styles */\n.my-custom-menu:not(.dark-theme) ion-list ion-item {\n  padding: 0px 0px 0px 0px;\n  height: 44px !important;\n}\n\n.my-custom-menu:not(.dark-theme) ion-list {\n  background: none !important;\n  --background: #fafaff !important;\n}\n\n.my-custom-menu:not(.dark-theme) ion-note {\n  margin-bottom: 30px;\n}\n\n.my-custom-menu:not(.dark-theme) ion-list-header,\n.my-custom-menu:not(.dark-theme) ion-note {\n  padding-left: 10px;\n}\n\n.my-custom-menu:not(.dark-theme) ion-list#inbox-list {\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\n}\n\n.my-custom-menu:not(.dark-theme) ion-list#inbox-list ion-list-header {\n  font-size: 16px;\n  min-height: 20px;\n}\n\n.my-custom-menu:not(.dark-theme) ion-list#labels-list ion-list-header {\n  font-size: 16px;\n  margin-bottom: 18px;\n  color: #757575;\n  min-height: 26px;\n}\n\n.my-custom-menu:not(.dark-theme) ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 4px;\n}\n\n.my-custom-menu:not(.dark-theme) ion-item.selected {\n  --background: var(--ion-highlight-background-color-sidemenu) !important;\n}\n\n.my-custom-menu:not(.dark-theme) ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\n.my-custom-menu:not(.dark-theme) ion-item ion-icon {\n  color: #616e7e;\n}\n\n.my-custom-menu:not(.dark-theme) ion-item.selected {\n  & ion-label {\n    color: var(--ion-color-primary) !important;\n  }\n  & span {\n    color: var(--ion-color-primary) !important;\n  }\n}\n\n/* Charter specific styles (dark theme) */\n.dark-theme ion-content {\n  --background: #121212 !important;\n  --color: white !important;\n}\n\n.dark-content {\n  background: #121212 !important;\n}\n\n.dark-toolbar {\n  --background: #1e1e1e !important;\n  --color: white !important;\n  border-bottom: 1px solid #333 !important;\n  padding-block: 15px;\n}\n\n.dark-list {\n  background: #121212 !important;\n}\n\n.dark-item {\n  --background: #121212 !important;\n  --color: white !important;\n  --border-color: #333 !important;\n}\n\n.dark-item.selected {\n  --background: #333 !important;\n}\n\n.dark-item ion-icon {\n  color: white !important;\n}\n\n.dark-footer {\n  background: #1e1e1e !important;\n}\n\n.dark-footer ion-item {\n  --background: #1e1e1e !important;\n  --color: white !important;\n}\n\n/* Profile Header (charter only) */\n.profile-header {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  width: 100%;\n  background-color: #1e1e1e;\n}\n\n.profile-image-container {\n  margin-inline: 15px;\n}\n\n.profile-image {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #ccc;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-name {\n  margin: 0 0 8px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n}\n\n.profile-email {\n  margin: 0;\n  font-size: 12px;\n  color: #aaa;\n}\n\n/* Default Header Styles */\n.defaultHeader .gravatar img {\n  border: 2px solid #444;\n  border-radius: 50%;\n}\n\n.custom-header-design label {\n  font-size: 16px;\n  display: block;\n  text-align: center;\n  margin-top: 8px;\n}\n\n/* Common utility classes */\n.select-radio-icon {\n  font-size: 2.4rem;\n  padding-right: 8px;\n}\n\n.login-submit-button-design {\n  width: 100%;\n  margin-top: 5px !important;\n  margin-left: 0px !important;\n  text-transform: none !important;\n}\n\n.app-version {\n  float: right;\n  font-size: 10px;\n  padding-top: 3px;\n  color: #acaaaa;\n}\n\n.wallet-fotter {\n  padding-left: 0px;\n  bottom: 4px;\n  padding: 5px !important;\n}\n\n.md .custom-heder-toolbar {\n  height: 171px !important;\n  min-height: 189px !important;\n  display: block !important;\n}\n\n.ios .custom-heder-toolbar {\n  height: 171px !important;\n  min-height: 210px !important;\n  display: block !important;\n}\n\n@media (min-width: 768px) {\n  .hide-all-lg {\n    display: none;\n  }\n}\n\n.wallet-footer {\n  margin-left: 80px;\n  line-height: 0.2;\n  margin-top: 11px;\n\n  @media (min-width: 768px) {\n    margin-left: 140px;\n  }\n}\n\n.left-padding {\n  padding: 16px 16px 16px 0;\n}\n\n.padding {\n  padding: 10px;\n}\n\nion-menu ion-content ion-list .item .sc-ion-label-md-h {\n  color: var(--ion-color-headertext) !important;\n}\n\n/* Vendor/Operator selected item style */\n.my-custom-menu:not(.dark-theme) ion-item.selected {\n  --background: var(--ion-highlight-background-color-sidemenu) !important;\n}\n\n.my-custom-menu:not(.dark-theme) ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\n/* Charter selected item style */\n.dark-item.selected {\n  --background: #333 !important;\n}\n\n.ios .dark-toolbar {\n  padding-top: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
